import styled from 'styled-components';

import { Row } from '@components/formStyles';

export const Overlay = styled.div`
  position: fixed;
  z-index: 100000;
  cursor: pointer;
  top: 0;
  left: 0;
  cursor: auto;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.darkGrey80};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-rows: 58px 1fr;
    gap: 10px 0;
  }
`;
export const TableContainer = styled.div`
  width: calc(100% - 240px);
  height: calc(100% - 48px);
  z-index: 1000;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    background-color: ${({ theme }) => theme.palette.white};
    width: 100%;
    height: 100%;
    overflow-x: auto;
    padding: 26px 0 22px 13px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: auto;
  overflow-x: auto;
  padding: 40px 20px 38px 20px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.white};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 100%;
    padding: 0 0 38px 0;

    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;

      background-color: ${({ theme }) => theme.palette.gray};
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: ${({ theme }) => theme.palette.brownishGrey};
    }
  }
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  position: relative;
`;

export const TableCol = styled.div`
  min-width: 166px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 61px;

    & img {
      max-height: 70%;
    }
  }
`;

export const InstallmentNumber = styled.div`
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: rgba(228, 248, 224);
  display: block;
  line-height: 68px;
  font-size: 14px;
  font-weight: 600;
  min-width: 166px;
  height: 68px;
  color: ${({ theme }) => theme.palette.darkGrey};
  &:first-child {
    visibility: hidden;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Total = styled.span`
  margin-right: 3px;
`;

export const Header = styled.div<{ isResponsive?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const ResponsiveHeader = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.white};
  border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-left: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    margin-left: 0;
  }
`;

export const CloseText = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.black};
  margin-right: 4px;
  cursor: pointer;
  text-align: right;
`;

export const CloseAction = styled(Row)`
  cursor: pointer;
`;

export const ResponsiveCloseAction = styled.div`
  margin-right: 11px;
  cursor: pointer;
`;
